// extracted by mini-css-extract-plugin
export default {"grid":"Credits_grid__WJ-5z","row":"Credits_row__E0RUN","buttonWrapper":"Credits_buttonWrapper__Gt-ba"};